import * as React from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import styled from "styled-components";
import Result from "./Result";

const columns = [
	{ id: "ngay", label: "NGÀY", minWidth: 50 },
	{ id: "chang", label: "CHẶNG", align: "center", minWidth: 50 },
	{
		id: "desc",
		label: "XUẤT PHÁT - ĐÍCH",
		minWidth: 100,
		align: "left",
		format: (value) => value.toLocaleString("en-US"),
	},
	{
		id: "culy",
		label: "CỰ LY",
		minWidth: 90,
		align: "left",
		format: (value) => value.toLocaleString("en-US"),
	},
	{
		id: "result",
		label: "KẾT QUẢ",
		minWidth: 90,
		align: "left",
		format: (value) => value.toFixed(2),
	},
];

function createData(id, ngay, chang, desc, culy, result) {
	return { id, ngay, chang, desc, culy, result };
}

export default function ListLoTrinh({ dataLoTrinh, isMobile }) {
	const page = 0;
	const rowsPerPage = 30;
	let rows = [];
	const listData = dataLoTrinh.items;
	if (listData) {
		listData.forEach((element) => {
			rows.push(
				createData(
					element.ldx_id,
					element.ldx_ngaydua,
					element.ldx_chang,
					element.ldx_noidung,
					element.ldx_culy,
					element.ldx_hinhanh
				)
			);
		});
	}

	return (
		<Container>
			<Paper
				sx={{ width: !isMobile ? "650px" : "100%", overflow: "hidden" }}
			>
				<TableContainer sx={{ maxHeight: 430 }}>
					<Table stickyHeader aria-label="sticky table">
						<TableHead>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										sx={{
											fontSize: ["1.2rem", "1.5rem"],
											paddingLeft: [1, 2],
											paddingRight: [1, 2],
										}}
										key={column.id}
										align={column.align}
										style={{ minWidth: column.minWidth }}
									>
										{column.label}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{rows
								.slice(
									page * rowsPerPage,
									page * rowsPerPage + rowsPerPage
								)
								.map((row) => {
									return (
										<TableRow
											hover
											role="checkbox"
											tabIndex={-1}
											key={row.id}
										>
											{columns.map((column) => {
												const value = row[column.id];
												return (
													<TableCell
														sx={{
															fontSize: "1.2rem",
															paddingLeft: [1, 2],
															paddingRight: [
																1, 2,
															],
														}}
														key={column.id}
														align={column.align}
													>
														{column.id ===
														"result" ? (
															<Result
																dataResult={
																	value
																}
															/>
														) : (
															value
														)}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
						</TableBody>
					</Table>
				</TableContainer>
			</Paper>
		</Container>
	);
}
const Container = styled.div`
	margin-top: 2rem;
`;
